import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { PaymentResult } from "../models/payment-result.model";
import JSZip from "jszip";



export class ReportsController {


    constructor(public _http: HttpClient) {
    }


    
    downloadExpirationsToContact(month,
        year, productId, vendorId, companyID,
        status, progressFunc: (progress: any) => void) {
      
          
        let path = `Licenses/downloadExpirationsToContact/${month}/${year}/${productId}/${vendorId}/${companyID}/${status}`

          return this.CreatePromiseDownload(path,progressFunc);
    
          

        }
    CreatePromiseDownload(path: string,progressFunc: (progress: any) => void) {
        let promise = new Promise<any>(resolve => {
    
            this._http.get(API_ADDRESS + `/${path}`, {
                responseType: "blob",
                reportProgress: true,
                observe: 'events'
            })
                .subscribe((event: HttpEvent<any>) => {

                    switch (event.type) {
                        case HttpEventType.Sent:
                            console.log('Request has been made!');
                            break;
                        case HttpEventType.ResponseHeader:
                            console.log('Response header has been received!');
                            break;
                        case HttpEventType.DownloadProgress:
                            let progress = Math.round(event.loaded / event.total * 100);
                            console.log(`Download! ${progress}%`);
                            break;
                        case HttpEventType.Response:
                            console.log('User successfully created!', event.body);

                            let result = event.body;

                            if (result.type != 'text/plain') {

                                var new_zip = new JSZip();

                                // more files !
                                new_zip.loadAsync(result)
                                    .then(function (zip) {
                                      
                                        Object.keys(zip.files).forEach(function (filename) {

                                        zip.files[filename].async("uint8array", (metadata) => {
                                            progressFunc(metadata.percent);
                                        })
                                            .then(data => {

                                                var blob = new Blob([data]);
                                                let saveAs = require('file-saver');
                                                let file = filename;
                                                saveAs(blob, file);
                                                resolve(blob);

                                                progressFunc(100);

                                            });

                                    });
                                });
                                

                            }
                            else {

                                alert('File not found in Blob!');
                            }

                        //     resolve(event.body);


                    }
                },
                    err => console.log(err)
                );

        });

        return promise;
    }
}





